"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importStar(require("@CommonFrontendBackend/FeatureFlag"));
var ImageImports_1 = require("Common/Utils/ImageImports");
var FontSelector_1 = __importDefault(require("SettingsAngular/BrandSetup/Fonts/TypographySelector/FontSelector/FontSelector"));
var RecommendedPairings_1 = __importDefault(require("SettingsAngular/BrandSetup/Fonts/TypographySelector/RecommendedPairings/RecommendedPairings"));
var FontService_1 = __importDefault(require("DreamCoat/BrandSetUp/BrandFonts/FontService/FontService"));
var attachBrandSetup_1 = require("Settings/NewBrandSetup/attachBrandSetup");
var Notifications_1 = __importDefault(require("./Notifications/Notifications"));
module.exports = function (user, usingFeature, upseller, userIconFactory, rolesService, state, make, account, brandStore, stylePermissionStore) {
    var usingNewBrandSetup = (0, FeatureFlag_1.isUsingNewBrandSetUp)(usingFeature);
    var fontSelector = make(FontSelector_1.default);
    var fontPairs = make(RecommendedPairings_1.default);
    var fontService = make(FontService_1.default, {
        account: account,
        fontSelector: fontSelector,
        fontPairs: fontPairs,
    });
    var brandSetupOverlay = make(attachBrandSetup_1.BrandSetupOverlay, {
        account: account,
        brandStore: brandStore,
        stylePermissionStore: stylePermissionStore,
        fontService: fontService,
    });
    var customDomainUpsell = {
        feature: "domain",
        featureLabel: "custom domain",
        customUpsellMessage: "Upgrade to set up a branded custom domain that doesn't reference to Qwilr (eg. documents.yourbusiness.com).",
    };
    var openBrandSetup = function (gotoState) {
        var brandSetupSections = allSettings["Brand & Appearance"].map(function (section) { return section.id; });
        return state.openBrandSetup(gotoState, brandSetupSections);
    };
    var userIcon = userIconFactory.create(user, { textColor: "#242C39", backgroundColor: "#B6B9BD" });
    var newBrandSetUpSettings = [
        {
            id: "brand",
            name: "Brand editor",
            icon: ImageImports_1.SettingsBrand,
            description: "Set up your brand style and permissions",
            adminOnly: true,
            onClick: function () {
                return brandSetupOverlay.show();
            },
        },
        {
            id: "subdomain",
            name: "Subdomain",
            description: "Manage your subdomain",
            icon: ImageImports_1.SettingsSubdomain,
            adminOnly: true,
            onClick: function () {
                if (!usingFeature(FeatureFlag_1.default.Subdomain)) {
                    return upseller.upsell({
                        feature: "subdomain",
                        featureLabel: "Custom Subdomain",
                    });
                }
                else {
                    return openBrandSetup("subdomain");
                }
            },
        },
        {
            id: "custom-domain",
            name: "Custom Domain",
            description: "Setup your custom domain",
            icon: ImageImports_1.SettingsCustomDomain,
            adminOnly: true,
            onClick: function () {
                if (!usingFeature(FeatureFlag_1.default.Domain)) {
                    return upseller.upsell(customDomainUpsell);
                }
                else {
                    return openBrandSetup("custom-domain");
                }
            },
        },
        {
            id: "link-preview",
            name: "Link Preview",
            description: "Change how your pages are previewed",
            icon: ImageImports_1.SettingsLinkPreview,
            adminOnly: true,
            controller: require("./LinkPreviewAccountDefaults/LinkPreviewAccountDefaults").default,
            onClick: usingFeature(FeatureFlag_1.default.LinkPreviewDefaultsOverride)
                ? undefined
                : function () {
                    return upseller.upsell({
                        feature: "linkPreviewDefaultsOverride",
                        featureLabel: "link preview defaults override",
                    });
                },
        },
    ];
    var oldBrandSetUpSettings = [
        {
            id: "colors",
            name: "Colors",
            icon: ImageImports_1.SettingsBrand,
            description: "Set your brand colors",
            adminOnly: true,
            onClick: function () {
                return openBrandSetup("colors");
            },
        },
        {
            id: "fonts",
            name: "Fonts",
            icon: ImageImports_1.SettingsFonts,
            description: "Choose your fonts",
            adminOnly: true,
            onClick: function () {
                return openBrandSetup("fonts");
            },
        },
        {
            id: "subdomain",
            name: "Subdomain",
            description: "Manage your subdomain",
            icon: ImageImports_1.SettingsSubdomain,
            adminOnly: true,
            onClick: function () {
                if (!usingFeature(FeatureFlag_1.default.Subdomain)) {
                    return upseller.upsell({
                        feature: "subdomain",
                        featureLabel: "Custom Subdomain",
                    });
                }
                else {
                    return openBrandSetup("subdomain");
                }
            },
        },
        {
            id: "custom-domain",
            name: "Custom Domain",
            description: "Setup your custom domain",
            icon: ImageImports_1.SettingsCustomDomain,
            adminOnly: true,
            onClick: function () {
                if (!usingFeature(FeatureFlag_1.default.Domain)) {
                    return upseller.upsell(customDomainUpsell);
                }
                else {
                    return openBrandSetup("custom-domain");
                }
            },
        },
        {
            id: "link-preview",
            name: "Link Preview",
            description: "Change how your pages are previewed",
            icon: ImageImports_1.SettingsLinkPreview,
            adminOnly: true,
            controller: require("./LinkPreviewAccountDefaults/LinkPreviewAccountDefaults").default,
            onClick: usingFeature(FeatureFlag_1.default.LinkPreviewDefaultsOverride)
                ? undefined
                : function () {
                    return upseller.upsell({
                        feature: "linkPreviewDefaultsOverride",
                        featureLabel: "link preview defaults override",
                    });
                },
        },
    ];
    var brandSetupSettings = usingNewBrandSetup ? newBrandSetUpSettings : oldBrandSetUpSettings;
    var allSettings = {
        Account: [
            {
                id: "account",
                name: "Account",
                description: "Company name and account settings",
                icon: ImageImports_1.SettingsAccount,
                adminOnly: true,
                controller: require("./Account/Account.ts").AccountController,
            },
            {
                id: "profile",
                name: "Profile",
                description: "Manage names, email and password",
                iconUi: userIcon,
                adminOnly: false,
                controller: require("./Profile/Profile.js"),
            },
            {
                id: "users",
                name: "Team",
                icon: ImageImports_1.SettingsTeam,
                description: "Invite team members to share and collaborate",
                adminOnly: false,
                controller: require("./Team/Team.js"),
            },
            {
                id: "subscription",
                name: "Subscription",
                icon: ImageImports_1.SettingsSubscription,
                description: "Manage your plan and credit cards",
                adminOnly: true,
                controller: require("./Subscription/Subscription.js"),
            },
            {
                id: "security",
                name: "Security",
                icon: ImageImports_1.SettingsSecurity,
                description: "Manage the safety and security of your account",
                adminOnly: true,
                displayNone: !usingFeature(FeatureFlag_1.default.OptionalLoginMethods),
                controller: require("./Security/Security").default,
            },
            {
                id: "notifications",
                name: "Notifications",
                icon: ImageImports_1.SettingsNotifications,
                description: "Adjust your notifications",
                adminOnly: false,
                controller: Notifications_1.default,
            },
            {
                id: "integrations",
                name: "Integrations",
                icon: ImageImports_1.SettingsIntegrations,
                description: "Connect Qwilr to other software",
                adminOnly: false,
                controller: require("./Integrations/IntegrationsController").default,
            },
            {
                id: "api",
                name: "Qwilr API",
                icon: ImageImports_1.SettingsApi,
                description: "Mass produce and automate Qwilr",
                adminOnly: true,
                upsell: false,
                controller: require("./ApiSettings/ApiSettings.js"),
            },
            {
                id: "reporting",
                name: "Analytics & Reporting",
                description: "Manage settings for metrics in analytics and reports",
                icon: ImageImports_1.SettingsAnalytics,
                adminOnly: true,
                controller: require("./Reports/AnalyticsAndReporting").default,
            },
        ],
        "Brand & Appearance": brandSetupSettings,
    };
    var availableSettings = {};
    for (var name in allSettings) {
        var items = allSettings[name];
        var filteredItems = items.filter(function (item) { return !item.displayNone && (rolesService.isAdmin(user) || !item.adminOnly); });
        if (filteredItems.length) {
            availableSettings[name] = filteredItems;
        }
    }
    return availableSettings;
};
